// extracted by mini-css-extract-plugin
export default {"main-container":"QuickbooksSSOCallback_main-container__l4PIB"};